import BaseComponent from "../../../../../lib/components/BaseComponent";
import {Box, ButtonBase, Tabs} from "@mui/material";
import {Component} from "react";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";
import BaseTab from "../../../../../appl/view/components/tabbar/BaseTab";

class TabBarCustomTabTest extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      value: 0,
    };
  }

  handleChange = (event, newValue) => {
    this.setState({value: newValue});
  };

  render() {
    const {value} = this.state;

    return (<VerticalLayout className="sandbox-container gap-4">
      <Box>
        <Tabs value={value} onChange={this.handleChange} centered>
          <BaseTab
            label="Custom Tab 1"
            selected={value === 0}
            onClick={() => this.handleChange(null, 0)}
          />
          <BaseTab
            label="Custom Tab 2"
            selected={value === 1}
            onClick={() => this.handleChange(null, 1)}
          />
          <BaseTab
            label="Custom Tab 3"
            selected={value === 2}
            onClick={() => this.handleChange(null, 2)}
          />
        </Tabs>

        {/* Inhalte der Tabs */}
        {value === 0 && <Box mt={2}>Inhalt für Tab mit Home-Icon</Box>}
        {value === 1 && <Box mt={2}>Inhalt für Tab mit Settings-Icon</Box>}
        {value === 2 && <Box mt={2}>Inhalt für Tab mit Info-Icon</Box>}
      </Box>
    </VerticalLayout>);
  }
}

export class TabPanel extends Component {
  render() {
    const {children, value, index} = this.props;
    return (<div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{padding: '16px'}}>
      <Box sx={{maxWidth: {xs: 320, sm: 480}, bgcolor: 'background.paper'}}>{children}</Box>
    </div>);
  }
}

export default TabBarCustomTabTest;
